import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTabletBreakpoint } from '@Hooks/withBreakpoints/withBreakpoint';

const openCloseResultsFilters = (Component) => {
  function OpenCloseResultsFiltersHOC(props) {
    const { isTablet, setOpenFilters, openHeatmapIndicator, heatmapFullScreenModeIndicator } = props;

    useEffect(() => {
      setOpenFilters(!isTablet);
    }, [isTablet]);

    useEffect(() => {
      if (openHeatmapIndicator && heatmapFullScreenModeIndicator) {
        setOpenFilters(false);
      }
    }, [openHeatmapIndicator, heatmapFullScreenModeIndicator]);

    return <Component {...props} />;
  }

  OpenCloseResultsFiltersHOC.propTypes = {
    isTablet: PropTypes.bool,
    setOpenFilters: PropTypes.func,
    openHeatmapIndicator: PropTypes.bool,
    heatmapFullScreenModeIndicator: PropTypes.bool,
  };

  return OpenCloseResultsFiltersHOC;
};
const openCloseResultsFiltersComposed = compose(withTabletBreakpoint(), openCloseResultsFilters);

export default openCloseResultsFiltersComposed;
